module.exports = __webpack_public_path__ + "static/img/govcard_01.7400ce9c.svg";